import { HttpClient } from '@angular/common/http';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { OCC_USER_ID_CURRENT, OccConfig, OccEndpointsService, UserIdService } from '@spartacus/core';
import { BehaviorSubject } from 'rxjs';
import { CookieService } from 'src/app/customServices/cookie.service';
import { AuthStorageService } from '@spartacus/core';
import { isPlatformBrowser } from '@angular/common';
@Injectable({
  providedIn: 'root',
})
export class ForgotPasswordService {
  private _successMsgSource = new BehaviorSubject<boolean>(false);
  successMsg$ = this._successMsgSource.asObservable();

  private canSetNEwCountry = new BehaviorSubject<boolean>(true);
  canSetNEwCountry$ = this.canSetNEwCountry.asObservable();
  //AuthToken
  authToken: any;
  //name of the remember me while log in cookie
  refreshTokenCookieName: string = `kbecomstorefrontRememberMeNA`;
  expiresOnForRememberMe: string = `kbecomstorefrontRememberMeneedtoExpiresOnNA`;
  customerId: string = `customerIdNA`;
  platformId = inject(PLATFORM_ID); 
  constructor(
    private http: HttpClient,
    private occService: OccEndpointsService,
    private cookieService: CookieService,
    private authStorageService: AuthStorageService,
    private config: OccConfig,
    private userIdService: UserIdService
  ) {}

  sendSuccessMsg(message: boolean) {
    this._successMsgSource.next(message);
  }
  canSetNewCountry(message: boolean) {
    this.canSetNEwCountry.next(message);
  }
  sendEmail(email) {
    return this.http.post(this.occService.buildUrl(`kblogin/sendforgotpasswordemail?userId=${email.email}`), email);
  }
  sendEmailToBackEnd(email) {
    return this.http.post(this.occService.buildUrl(`backofficepasswordreset/requestbackofficeuser?id=${email}`), null);
  }

  resetPassword(data) {
    return this.http.post(
      this.occService.buildUrl(
        `backofficepasswordreset/backofficepasswordreset?token=${data?.token}&pwd=${data?.pwd}&checkPwd=${data?.checkPwd}`
      ),
      null
    );
  }

  updatePassword(data: any) {
    return this.http.post(
      this.occService.buildUrl(`kblogin/resetpassword?token=${data?.token}&newPassword=${data?.newpassword}`),
      data
    );
  }
  getnewAccessToken(): any {
    let accessToken;
    this.authStorageService.getToken().subscribe((x) => {
      accessToken = x.access_token;
    });
    return accessToken;
  }

  renewToken(tokenApi) {
    return this.http.post<any>(
      `${this.config?.backend?.occ?.baseUrl}/authorizationserver/oauth/token?client_id=mobile_android&client_secret=secret&grant_type=refresh_token&refresh_token=${tokenApi.refresh_token}`,
      null
    );
  }

  storeNewAccessToken(tokenValue) {
    const storedAt = Date.now();
    const ExpiresAt = storedAt + 59000;

    const dataformat = {
      access_token: tokenValue,
      access_token_stored_at: JSON.stringify(storedAt),
      expires_at: JSON.stringify(ExpiresAt),
      granted_scopes: ['basic', 'openid'],
      token_type: 'bearer',
    };
    const userdata = {
      token: dataformat,
      userId: 'current',
    };
    const accToken = {
      access_token: tokenValue,
    };
    const jsonateData = JSON.stringify(accToken);
    const parsedacctoken = JSON.parse(jsonateData);
    this.authStorageService.setToken(dataformat);
    this.authStorageService.setItem('access_token', parsedacctoken.access_token);
    if (isPlatformBrowser(this.platformId)) {
    window.localStorage.setItem('spartacus⚿⚿auth', JSON.stringify(userdata));
    }
    this.userIdService.setUserId(OCC_USER_ID_CURRENT);
  }

  getRefreshToken() {
    return this.cookieService.getCookieValue(this.refreshTokenCookieName);
  }
  setRefreshToken(refreshToken: string) {
    const fourteenDays = 7 * 24 * 60 * 60 * 1000;
    const expirationDate = new Date(Date.now() + fourteenDays);
    const cookieString = `${
      this.refreshTokenCookieName
    }=${refreshToken}; expires=${expirationDate.toUTCString()}; path=/`;
    const expiryDate = `${
      this.expiresOnForRememberMe
    }=${expirationDate.toUTCString()} ;expires=${expirationDate.toUTCString()}; path=/`;
    const isExist = this.cookieService.isCookieSet(this.refreshTokenCookieName);
    if (isExist) {
      if (isPlatformBrowser(this.platformId)) {
      document.cookie = cookieString;
      }
      this.setExpiryDate();
    } else {
      if (isPlatformBrowser(this.platformId)) {
      document.cookie = cookieString;
      document.cookie = expiryDate;
      }
    }
  }
  setExpiryDate() {
    const currentdate = new Date(Date.now());
    const datePinned = this.cookieService.getCookieValue(this.expiresOnForRememberMe);
    const lastSetdate: Date = new Date(datePinned);
    const Pendingdays = this.calculateDaysDifference(currentdate, lastSetdate);
    if (Pendingdays <= 1) {
      this.deleteRefreshTokenCookie();
    }
  }

  calculateDaysDifference(date1: Date, date2: Date): number {
    const diffInMilliseconds = Math.round(date2.getTime() - date1.getTime());
    const diffInDays = Math.ceil(diffInMilliseconds / (1000 * 3600 * 24));
    return diffInDays;
  }

  deleteRefreshTokenCookie() {
    const fourteenDays = 14 * 24 * 60 * 60 * 1000;
    const expirationDate = new Date(Date.now() - fourteenDays);
    const cookieString = `${this.refreshTokenCookieName}='null'; expires=${expirationDate.toUTCString()}; path=/`;
    const expiryDate = `${
      this.expiresOnForRememberMe
    }=${expirationDate.toUTCString()} ;expires=${expirationDate.toUTCString()}; path=/`;
    const customerId = `${
      this.customerId
    }=${expirationDate.toUTCString()} ;expires=${expirationDate.toUTCString()}; path=/`;
    if (isPlatformBrowser(this.platformId)) {
    document.cookie = cookieString;
    document.cookie = expiryDate;
    document.cookie = customerId;
    }
  }
}
